module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "rows-per-page-items": [10, 25, 50],
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.data,
      "search": _vm.search,
      "select-all": _vm.selectable,
      "full-width": "",
      "dense": "",
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(_vm.selectable) ? _c('td', [_c('v-checkbox', {
          attrs: {
            "input-value": props.selected,
            "primary": "",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.headers), function(header) {
          return _c('td', {
            key: header.value
          }, [_vm._v(_vm._s(props.item[header.value]))])
        }), _vm._v(" "), _c('td', [_c('v-menu', {
          attrs: {
            "bottom": "",
            "left": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
          attrs: {
            "dense": ""
          }
        }, _vm._l((_vm.actions), function(action) {
          return _c('v-list-tile', {
            key: action.icon,
            on: {
              "click": function($event) {
                return _vm.$emit(action.action, props.item)
              }
            }
          }, [_c('v-list-tile-title', [_c('v-icon', [_vm._v(_vm._s(action.icon))]), _vm._v("\n                    " + _vm._s(action.text) + "\n                  ")], 1)], 1)
        }), 1)], 1)], 1)], 2)]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87239e6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/Table.vue
// module id = 1491
// module chunks = 9